import { PrinterType } from '@/types'
import { Badge } from '@/components/ui/badge'

export function PrinterTypeBadge({ type }: { type: PrinterType }) {
  const config = {
    [PrinterType.RECEIPT]: { label: 'Receipt', className: 'bg-slate-500/10 text-slate-700 border-slate-500/20' },
    [PrinterType.LABEL]: { label: 'Label', className: 'bg-slate-500/10 text-slate-700 border-slate-500/20' },
    [PrinterType.PDF]: { label: 'PDF', className: 'bg-slate-500/10 text-slate-700 border-slate-500/20' },
  }
  const { label, className } = config[type] ?? { label: type, className: '' }
  return <Badge variant="outline" className={`font-medium text-xs ${className}`}>{label}</Badge>
}
